import { Card } from "@mui/material";
import { JSX, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { ActionMenuItem } from "../../../components/action-menu/ActionMenuItem";
import { IUICustomizationPresetDescriptionDTO } from "../../../services/ui-customization-data-service/Models";
import UICustomizationPresetCardHeader from "./UICustomizationPresetCardHeader";

export type UICustomizationPresetCardProps = {
    preset: IUICustomizationPresetDescriptionDTO;
    variant?: "elevation" | "outlined";
    elevation?: number;
    onEdit?: (preset: IUICustomizationPresetDescriptionDTO) => void;
    onDelete?: (preset: IUICustomizationPresetDescriptionDTO) => void;
};

export default function UICustomizationPresetCard({
    preset,
    variant,
    elevation,
    onEdit,
    onDelete,
    children
}: PropsWithChildren<UICustomizationPresetCardProps>): JSX.Element {
    const { t } = useTranslation();
    const actionItems = new Array<ActionMenuItem>();

    if (onEdit) {
        actionItems.push({
            label: t("actions.edit"),
            onClick: () => {
                onEdit(preset);
            }
        });
    }

    if (onDelete) {
        actionItems.push({
            label: t("actions.delete"),
            onClick: () => {
                onDelete(preset);
            }
        });
    }

    return (
        <Card variant={variant} elevation={elevation}>
            <UICustomizationPresetCardHeader preset={preset} actionItems={actionItems} />
            {children}
        </Card >
    );
}


